<template>
  <div class="Service">
    <van-nav-bar title="联系客服" fixed @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-cell title="在线客服"  @click="onClickService">
      <template slot="icon">
        <img src="../../assets/img/icon/kefu2.png" class="icon" />
      </template>
      </van-cell>
      <van-cell title="客服小蜜" @click="onClickServer">
        <template slot="icon">
          <img src="../../assets/img/icon/kefu1.png" class="icon" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "Service",
  data() {
    return {
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

    };
  },
  methods: {
    loadData() {},
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "My",
        query: {
          active: 3
        }
      });
      // this.$router.go(-1);
    },
    // 客服小蜜
    onClickServer() {
      this.$router.push({
        name: "ServiceChatroom",
        query: {
          url: "Service"
        }
      });
    },
    // 在线客服
    onClickService() {
      
      this.$router.push({
        name: "OnlineService"
      });
    }
  },
  created() {
    this.loadData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AddressList/Service.vue